import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';

import {
  ActivityEventNames, GetTagsByIdsForQueryGQL, GetTagsByIdsForQueryQuery, SearchActivityEvents
} from 'generated/graphql';

import { MassApplyTagsOperationData } from 'app/quick-apply/types/mass-operation-types';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import { MassOperationActivityEventPayload } from '../types';

@Component({
  selector: 'app-mass-apply-tags-event',
  templateUrl: './mass-apply-tags-event.component.html'
})

export class ASMassApplyTagsEventComponent extends
  WithDisposableSubject() implements OnInit {

  @Input() item: SearchActivityEvents.Node;

  get payload(): MassOperationActivityEventPayload<MassApplyTagsOperationData> {
    return this.item?.payload;
  }

  appliedTags: GetTagsByIdsForQueryQuery['getTagsByIds'] = [];

  /**
   *
   */
  constructor(
    private _getTagsService: GetTagsByIdsForQueryGQL,
    private _cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    const tagIds = this.payload.operationData.tags?.map(t => t?.tagId);
    this._getTags(tagIds).subscribe(
      (tags) => {
        this.appliedTags = tags;
        this._cd.markForCheck();
      }
    );
  }

  private _getTags(tagIds: string[]) {
    return this._getTagsService.fetch({
      tagIds
    }).pipe(
      map(({data}) => data.getTagsByIds)
    );
  }
}
